import React, { useState } from 'react';
import { HomeMonitor } from '../components/HomeMonitor';
import { DeviceGrid } from '../components/DeviceGrid';
import { EnergyUsage } from '../components/EnergyUsage';
import { SetupGuide } from '../components/SetupGuide';
import { HomeIcon, SettingsIcon, BellIcon, BarChartIcon } from 'lucide-react';
export function Dashboard() {
  const [activeTab, setActiveTab] = useState('dashboard');
  return <div className="p-6 max-w-7xl mx-auto" data-id="element-546">
      <header className="flex justify-between items-center mb-8" data-id="element-547">
        <div data-id="element-548">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-549">
            WattWise Dashboard
          </h1>
          <p className="text-gray-500" data-id="element-550">
            Monitor and control your smart home devices
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-551">
          <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200" data-id="element-552">
            <BellIcon size={20} data-id="element-553" />
          </button>
          <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200" data-id="element-554">
            <SettingsIcon size={20} data-id="element-555" />
          </button>
        </div>
      </header>
      <div className="flex gap-4 mb-6" data-id="element-556">
        <button className={`flex items-center gap-2 px-4 py-2 rounded-lg ${activeTab === 'dashboard' ? 'bg-green-100 text-green-600' : 'bg-white text-gray-600'}`} onClick={() => setActiveTab('dashboard')} data-id="element-557">
          <HomeIcon size={18} data-id="element-558" />
          Dashboard
        </button>
        <button className={`flex items-center gap-2 px-4 py-2 rounded-lg ${activeTab === 'energy' ? 'bg-green-100 text-green-600' : 'bg-white text-gray-600'}`} onClick={() => setActiveTab('energy')} data-id="element-559">
          <BarChartIcon size={18} data-id="element-560" />
          Energy Usage
        </button>
        <button className={`flex items-center gap-2 px-4 py-2 rounded-lg ${activeTab === 'setup' ? 'bg-green-100 text-green-600' : 'bg-white text-gray-600'}`} onClick={() => setActiveTab('setup')} data-id="element-561">
          <SettingsIcon size={18} data-id="element-562" />
          Setup Guide
        </button>
      </div>
      {activeTab === 'dashboard' && <>
          <HomeMonitor data-id="element-563" />
          <DeviceGrid data-id="element-564" />
        </>}
      {activeTab === 'energy' && <EnergyUsage data-id="element-565" />}
      {activeTab === 'setup' && <SetupGuide data-id="element-566" />}
    </div>;
}